jQuery.feature_import("js-notifiation-admin",
    () => require("./NotificationAdminPage"),
    mod => mod.feature_js_notifiation_admin
);